import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { platform } from '@shared/lib/platform';

/**
 * The app's press and outcome vibrations, native only (the web has none to give).
 * `tap` is the light tick buttons, toggles and tabs give under the finger; `success`,
 * `warning` and `error` mark how an action ended, once, when it ends.
 */
export const haptics = {
  tap: (): void => {
    if (platform.isNative()) Haptics.impact({ style: ImpactStyle.Light }).catch(() => undefined);
  },
  success: (): void => notify(NotificationType.Success),
  warning: (): void => notify(NotificationType.Warning),
  error: (): void => notify(NotificationType.Error),
};

function notify(type: NotificationType): void {
  if (platform.isNative()) Haptics.notification({ type }).catch(() => undefined);
}
